// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__10wFS","rootCenter":"LoadMoreObserver_rootCenter__3xuL8","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__34stR"};